import React from "react";
import UserModal from "../../components/EmailModal/UserModal";
import { PropTypes } from 'prop-types';

export const CertificateModal = ({
  showCertModal,
  hideCert,
  certificateUrl,
}) => {
  return (
    <UserModal
      open={showCertModal}
      close={hideCert}
      height={"739"}
      width={"1000"}
    >
      <div style={{ padding: "20px" }}>
        <span
          className="iframe-back2"
          data-testid="cancel"
          onClick={() => hideCert()}
        >
          X
        </span>
        <embed
          src={certificateUrl}
          type="application/pdf"
          width="100%"
          height="1000"
          title="POS Certificate"
          name="Nibss Certificate"
        ></embed>
      </div>
    </UserModal>
  );
};

CertificateModal.propTypes = {
  showCertModal: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool
  ]),
  hideCert: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool
  ]),
  certificateUrl: PropTypes.string
}

export default CertificateModal;
